function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesSmartphoneSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6396ED"
    },
    points: "371.13,434.515 362.433,363.711 284.575,342.813 305.473,434.515 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9DC1FF"
    },
    points: "248.512,363.711 239.816,434.515 305.473,434.515 305.473,342.813 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6396ED"
    },
    d: "M492.868,50.24H305.473l-31.347,274.302L512,293.196V69.372C512,58.805,503.434,50.24,492.868,50.24z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DC1FF"
    },
    d: "M305.473,50.24H118.078c-10.566,0-19.132,8.565-19.132,19.132v125.775l29.404,98.048l177.123,31.347 V50.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E6BD6"
    },
    d: "M305.473,363.711h56.961h130.435c10.566,0,19.132-8.566,19.132-19.132v-51.384H305.473 l-20.898,35.259L305.473,363.711z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6396ED"
    },
    points: "305.473,293.195 128.35,293.195 149.498,363.711 248.512,363.711 305.473,363.711 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#003DA6"
    },
    points: "305.473,418.842 284.575,434.515 305.473,450.189 411.225,450.189 411.225,418.842 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.722,
    y: 418.847,
    style: {
      fill: "#2E6BD6"
    },
    width: 105.754,
    height: 31.347
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF0035"
    },
    points: "74.749,430.742 149.498,409.844 149.498,247.062 74.749,226.164 53.851,328.454 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF5450"
    },
    points: "74.749,226.164 0,247.062 0,409.844 74.749,430.742  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5450"
    },
    d: "M136.808,195.147h-62.06l-20.898,25.958l20.898,25.958h74.749v-39.228 C149.498,200.828,143.817,195.147,136.808,195.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5450"
    },
    d: "M74.749,461.759h62.061c7.008,0,12.688-5.681,12.688-12.689v-39.227H74.749L53.851,435.8 L74.749,461.759z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9491"
    },
    d: "M74.749,195.147h-62.06C5.681,195.147,0,200.828,0,207.836v39.228h74.749V195.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9491"
    },
    d: "M0,409.844v39.227c0,7.008,5.681,12.689,12.689,12.689h62.06v-51.915H0V409.844z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesSmartphoneSvgrepoCom);
export default __webpack_public_path__ + "static/media/devices-smartphone-svgrepo-com.befb9f675ba6e57b15a0e43ec7dbc53d.svg";
export { ForwardRef as ReactComponent };